import React from 'react';

export default function ConversionMetricsCard({ metrics }) {
  const { sipRate, avgSipRating, sipCount } = metrics?.conversions || {};
  const { completedCount, visitorCount, completionRate } = metrics?.completionMetrics || {};

  // Rating emoji based on score
  const getRatingEmoji = (rating) => {
    if (!rating) return null;
    const num = parseFloat(rating);
    if (num >= 4.5) return { emoji: '1', label: 'Loved it' };
    if (num >= 3.5) return { emoji: '2', label: 'Liked it' };
    if (num >= 2.5) return { emoji: '3', label: 'It was okay' };
    if (num >= 1.5) return { emoji: '4', label: 'Not for me' };
    return { emoji: '5', label: 'Disliked' };
  };

  const ratingInfo = getRatingEmoji(avgSipRating);

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-sm font-medium text-gray-500 mb-4">Conversion Metrics</h3>

      <div className="space-y-4">
        {/* Wine Rating Rate */}
        <div className="flex items-start justify-between pb-4 border-b border-gray-100">
          <div>
            <p className="text-sm text-gray-600">Wine Rating Rate</p>
            <p className="text-xs text-gray-400 mt-1">% of visitors who rated wines</p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold text-gray-900">{sipRate}%</p>
            <p className="text-xs text-gray-500">{sipCount} ratings</p>
          </div>
        </div>

        {/* Average Rating */}
        {avgSipRating && (
          <div className="flex items-start justify-between pb-4 border-b border-gray-100">
            <div>
              <p className="text-sm text-gray-600">Average Wine Rating</p>
              <p className="text-xs text-gray-400 mt-1">How visitors rated your wines</p>
            </div>
            <div className="text-right flex items-center gap-2">
              <span className="text-2xl">{ratingInfo?.emoji}</span>
              <div>
                <p className="text-xl font-bold text-gray-900">{avgSipRating}</p>
                <p className="text-xs text-gray-500">{ratingInfo?.label}</p>
              </div>
            </div>
          </div>
        )}

        {/* Passport Completion */}
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm text-gray-600">Visitor Completion Rate</p>
            <p className="text-xs text-gray-400 mt-1">% of your visitors who completed the passport</p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold text-gray-900">{completionRate}%</p>
            <p className="text-xs text-gray-500">{completedCount} of {visitorCount}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
